/**
 * 用户api
 * date:2022 04 20
 */
import httpRequest from '@/utils/request.js';

/**获取用户列表接口 */
export const accountList = (params = {}) => httpRequest.httpGet({
    url: '/service/account/list', params: {
        ...params
    }
})
/**获取客户列表接口 */
export const accountCustomer = (params = {}) => httpRequest.httpGet({
    url: '/service/account/customer', params: {
        ...params
    }
})
/**获取角色接口 */
export const accountRole = (params = {}) => httpRequest.httpGet({
    url: '/service/account/role', params: {
        ...params
    }
})
/**获取架构树接口 */
export const accountStructure = (params = {}) => httpRequest.httpGet({
    url: '/service/account/structure', params: {
        ...params
    }
})
/**获取用户详细接口 */
export const accountDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/account/detail', params: {
        ...params
    }
})
/**新增接口 */
export const accountNew = (data) => httpRequest.httpPost('/service/account/new', data)
/**编辑接口 */
export const accountEdit = (data) => httpRequest.httpPut('/service/account/edit', data)
/**单条同步接口 */
export const accountSync= (id) => httpRequest.httpPut('/service/account/sync?id='+id)
/**删除接口 */
export const accountRemove = (data) => httpRequest.httpdelete('/service/account/remove', data)
/**重置密码接口 */
export const accountPassword = (id) => httpRequest.httpPut('/service/account/password?id='+id)